import axios from "axios";

const API_BASE =
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_URL ||
    "https://api.shrianshnexus.in";

const ADMIN_BASE =
    process.env.REACT_APP_ADMIN_URL ||
    "https://admin.shrianshnexus.in";

axios.defaults.withCredentials = true;

export async function getCurrentUser() {
    const response = await axios.get(
        `${API_BASE}/api/auth/me`,
        {
            withCredentials: true
        }
    );

    return response.data;
}

export async function logout() {
    await axios.post(
        `${API_BASE}/api/auth/logout`,
        {},
        {
            withCredentials: true
        }
    );
}

function buildPublicAuthReturnUrl(returnUrl = window.location.href) {
    const url = new URL(returnUrl, window.location.origin);

    // This flag tells generator page:
    // “User has just returned from login/signup, now auto-claim pending preview.”
    url.searchParams.set("authReturn", "1");

    return url.toString();
}

export function redirectToLogin(returnUrl = window.location.href) {
    const authReturnUrl = buildPublicAuthReturnUrl(returnUrl);
    const encoded = encodeURIComponent(authReturnUrl);

    window.location.href = `${ADMIN_BASE}/login?entry=public&returnUrl=${encoded}`;
}

export function redirectToSignup(returnUrl = window.location.href) {
    const authReturnUrl = buildPublicAuthReturnUrl(returnUrl);
    const encoded = encodeURIComponent(authReturnUrl);

    window.location.href = `${ADMIN_BASE}/signup?entry=public&returnUrl=${encoded}`;
}